import React from 'react';

const bgClass = {
  blue: 'bg-[#3f83f8]',
  default: 'bg-[#1f334b]',
} as const;

interface ProBadgeProps {
  variant?: keyof typeof bgClass;
}

export const ProBadge: React.FC<ProBadgeProps> = ({ variant = 'default' }) => (
  <div className={`h-[22px] px-1 ${bgClass[variant]} rounded justify-center items-center inline-flex overflow-hidden`}>
    <div className="text-center text-white text-base font-extrabold">PRO</div>
  </div>
);
